import { Upload } from "lucide-react";
import { ImageCropModal } from "@/admin/ImageCropModal";
import { FIELD_CLASS, LABEL_CLASS } from "./shared";

// Name, slug (new only), type, tagline, and the required main photo upload for new products.
export const BasicInfoSection = ({ isNew, config, form, thumbUploading, thumbCrop, handleNameChange, handleSlugChange, handleField }) => (
  <>
    <label className="block">
      <span className={LABEL_CLASS}>Name</span>
      <input data-testid="admin-field-name" required value={form.name} onChange={(e) => handleNameChange(e.target.value)} className={FIELD_CLASS} />
      <p className="text-white/40 text-xs mt-1.5">Include the brand in the name (e.g. "EEZI-AWN Xplor") — there's no separate brand field, the name is the single source of truth.</p>
    </label>
    {isNew && (
      <label className="block">
        <span className={LABEL_CLASS}>Slug (URL path, unique)</span>
        <input data-testid="admin-field-slug" required value={form.slug} onChange={(e) => handleSlugChange(e.target.value)} className={FIELD_CLASS} placeholder="auto-generated from name" />
        {form.slug && <p className="text-white/40 text-xs mt-1.5">Product page will be: {config.storefrontPath}/{form.slug}</p>}
      </label>
    )}
    <label className="block">
      <span className={LABEL_CLASS}>Type</span>
      <select data-testid="admin-field-type" value={form.type} onChange={(e) => handleField("type", e.target.value)} className={FIELD_CLASS}>
        {config.typeOptions.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
    </label>
    <label className="block">
      <span className={LABEL_CLASS}>Tagline</span>
      <input data-testid="admin-field-tagline" value={form.tagline} onChange={(e) => handleField("tagline", e.target.value)} className={FIELD_CLASS} />
    </label>
    {isNew && (
      <div>
        <span className={LABEL_CLASS}>Main Photo</span>
        <div className="mt-2 flex items-center gap-4">
          {form.thumb && (
            <img src={form.thumb} alt="Main product photo preview" data-testid="admin-thumb-preview" className="w-24 h-24 object-cover border border-[var(--border-default)]" />
          )}
          <label className="inline-flex items-center gap-2 btn-secondary cursor-pointer" data-testid="admin-thumb-upload-label">
            <Upload size={14} /> {thumbUploading ? "Uploading…" : form.thumb ? "Replace Photo" : "Upload Photo"}
            <input
              type="file"
              accept="image/*"
              data-testid="admin-thumb-upload-input"
              className="hidden"
              disabled={thumbUploading}
              onChange={(e) => {
                if (e.target.files?.[0]) thumbCrop.selectFile(e.target.files[0]);
                e.target.value = "";
              }}
            />
          </label>
        </div>
        {!form.thumb && <p className="text-white/40 text-xs mt-1.5">A main photo is required before creating the product.</p>}
      </div>
    )}
    <ImageCropModal
      open={thumbCrop.isOpen}
      imageSrc={thumbCrop.imageSrc}
      fileName={thumbCrop.fileName}
      onCancel={thumbCrop.cancel}
      onConfirm={thumbCrop.confirm}
    />
  </>
);
